Drupal.behaviors.rounded_menu = {
  attach() {
    var element = document.querySelector('.rounded-full.w-20.h-20');

    var params = new URLSearchParams(window.location.search);
    var category = params.get('category');
    if (category) {
      document.querySelectorAll('.rounded-menu-list a').forEach((el) => {
        var href = el.getAttribute('href');
        if(!href.includes('?category')){
          href = href + '?category=' + category;
          el.setAttribute('href', href);
        }
      });
    }
    if (!element) {
      return;
    }

    var toggleButtons = (scrollLeft) => {
      if (document.querySelector('.rounded-menu').scrollWidth > document.querySelector('.rounded-menu').clientWidth) {
        if (scrollLeft == 0) {
          document.querySelector('.scroll-left').classList.add('md:hidden');
          document.querySelector('.scroll-left').classList.remove('md:show');
          document.querySelector('.scroll-right').classList.add('md:show');
          document.querySelector('.scroll-right').classList.remove('md:hidden');
        }
        if (scrollLeft > 0) {
          document.querySelector('.scroll-right').classList.remove('md:show');
          document.querySelector('.scroll-right').classList.add('md:hidden');
          document.querySelector('.scroll-left').classList.remove('md:hidden');
          document.querySelector('.scroll-left').classList.add('md:show');
        }
      }
      else {
        document.querySelector('.scroll-left').classList.add('md:hidden');
        document.querySelector('.scroll-left').classList.remove('md:show');
        document.querySelector('.scroll-right').classList.add('md:hidden');
        document.querySelector('.scroll-right').classList.remove('md:show');
      }
    };

    document.querySelector('.rounded-menu').scrollLeft = element.getBoundingClientRect().left - 50
    toggleButtons(document.querySelector('.rounded-menu').scrollLeft);

    document.querySelector('.scroll-right').addEventListener('click', (event) => {
      document.querySelector('.rounded-menu').scrollLeft = 5000;
      toggleButtons(1);
    });

    document.querySelector('.scroll-left').addEventListener('click', (event) => {
      document.querySelector('.rounded-menu').scrollLeft = 0;
      toggleButtons(0);
    });

    toggleButtons(document.querySelector('.rounded-menu').scrollLeft);


    window.addEventListener('resize', toggleButtons);

  }
}
